'use client'
import * as React from 'react'
import {heroSectionData} from 'content/blog'
import classes from './styles.module.css'
import clsx from 'clsx'
import Navigation from 'v1/common-components/navigation/Navigation'
import DebouncedInput from '../debounced-input/DebouncedInput'
import {useRouter} from 'next/navigation'
import Image from 'next/image'
import heroImage from "assets/blogs/HeroImage.svg";

export default function BlogHero() {
  const router = useRouter()

  const handleSearch = (text: string) => {
    if (text.trim()) {
      // Only navigate if there's actual text
      router.push(`/blogs/search?q=${encodeURIComponent(text.trim())}`, {scroll: false})
    }
    // Importantly, we DON'T navigate to /blogs if the search is empty
    // This prevents the automatic redirect back to /blogs
  }

  return (
    <div className={classes.container}>
      <div className={classes.subContainer}>
        <Navigation />
        <div className={classes.content}>
          <div className={classes.textPlusSearch}>
            <div className={classes.text}>
              <h2 className={classes.header}>{heroSectionData.title}</h2>
              <p className={classes.desc}>{heroSectionData.desc}</p>
            </div>
            <DebouncedInput
              onSearch={handleSearch}
              debounceMs={500} // Shorter debounce for better UX in header
              immediate={false}
              serverSide={false}
              preventRedirect={true} // Add this new prop
            />
          </div>
          <div className={classes.heroImageSection}>
            <Image src={heroImage} alt="cookie" className={classes.cookieImg} />
          </div>
        </div>
      </div>
    </div>
  )
}
